import XcolumnFunc from "@/pcomponents/common/xcolumn/xcolumn/xcolumn_func";
//const xColumnArr=getXcolumnJson();

const getXcolumnJson=()=>{
  let initData:any={
    table:"shop_order",
    list_id:"shop_order_list_month",
    x_column_list_arr:[
      {"key":"row_view_row_num","name":"No.","width":"50","is_show":"1"},
      {"key":"mcomp_name","name":"요청학원","width":"120","is_show":"1"},
      {"key":"row_tot","name":"주문량","width":"100","is_show":"1"},
      {"key":"a_amount","name":"수량","width":"100","is_show":"1"},
      {"key":"a_price_sum","name":"가격","width":"100","is_show":"1"},
      {"key":"a_pay_money","name":"납부액","width":"100","is_show":"1"},
    ],
    list_opt_origin:{
      'now_page':1,
      'num_per_page':30,
      'order_id':'',
      'order_type':'',
      's_date_type':'',
      's_start_date':'',
      's_end_date':'',
      'sc':{},
    },
    order_id_col_arr:[
      {"value":"","text":"없음"},
    ]
  };
  initData.pri_col_arr=["a_ymd","a_seq"];
  const xColumnArr:any=XcolumnFunc.getDefaultXcolumn(initData);

  return xColumnArr;
};

export default getXcolumnJson;